import axios from './http'

export function initData(token) {
  return axios({
    url: '/api/product/initData',
    headers: {
      'authorization': token
    },
    method: 'post'
  })
}

export function searchProduct(token, data) {
  return axios({
    url: '/api/product/searchProduct',
    headers: {
      'authorization': token
    },
    method: 'post',
    data: data
  })
}

export function uploadProductImage(token, formData, productId, supplierId) {
  return axios({
    url: '/api/product/uploadProductImage',
    headers: {
      'authorization': token,
      'productId': productId,
      'Content-Type': 'multipart/form-data',
      'supplierId': supplierId
    },
    method: 'post',
    data: formData
  })
}

export function queryProductPackage(token, productId) {
  return axios({
    url: '/api/product/queryProductPackage/' + productId,
    headers: {
      'authorization': token,
    },
    method: 'get',
  })
}


export function queryProductBarcode(token, barcode) {
  return axios({
    url: '/api/product/queryProductBarcode/' + barcode,
    headers: {
      'authorization': token,
    },
    method: 'get',
  })
}

export function deleteProduct(token, productId) {
  return axios({
    url: '/api/product/deleteProduct',
    headers: {
      'authorization': token,
      'productId': productId
    },
    method: 'delete'
  })
}

export function downloadTemplate(token, data) {
  return axios({
    url: '/api/product/downloadTemplate',
    headers: {
      'authorization': token
    },
    responseType: 'blob',
    method: 'post',
    data: data
  })
}

export function uploadTemplate(token, params, supplierId) {
  return axios({
    url: '/api/product/uploadTemplate',
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data',
      'supplierId': supplierId
    },
    method: 'post',
    data: params
  })
}

export function addParentBrand(token, param) {
  return axios({
    url: '/api/product/addParentBrand',
    headers: {
      'authorization': token
    },
    method: 'post',
    data: param
  })
}

export function addBrandName(token, param) {
  return axios({
    url: '/api/product/addBrandName',
    headers: {
      'authorization': token
    },
    method: 'post',
    data: param
  })
}

export function queryProduct(token,supplierId) {
  return axios({
    url: '/api/product/queryProduct/'+supplierId,
    headers: {
      'authorization': token
    },
    method: 'GET'
  })
}
